import AuthActionTypes from 'store/modules/auth/constants';
import { ApplicationActions } from 'store/types';

import ActionTypes from './constants';
import { InvitationsState } from './types';

export const initialState: InvitationsState = [];

export default function invitationsReducer(
  state: InvitationsState = initialState,
  action: ApplicationActions
): InvitationsState {
  switch (action.type) {
    case ActionTypes.LOAD_CURRENT_ENTERPRISE_INVITATIONS_SUCCESS: {
      const {
        payload: { invitations }
      } = action;
      return invitations;
    }
    case ActionTypes.ADD_INVITATION_SUCCESS: {
      const {
        payload: { invitation }
      } = action;
      return [
        ...state,
        invitation
      ];
    }
    case ActionTypes.UPDATE_INVITATION_SUCCESS: {
      const {
        payload: { sid, updatedInvitation }
      } = action;
      const prevInvitation = state.find((i) => i.sid === sid);
      if (prevInvitation) {
        return [
          ...state.filter((i) => i.sid !== sid),
          {
            ...prevInvitation,
            role: updatedInvitation.role
          }
        ];
      }
      return state;
    }
    case ActionTypes.ACCEPT_INVITATION_SUCCESS:
    case ActionTypes.DELETE_INVITATION_SUCCESS: {
      const {
        payload: { invitationSid }
      } = action;
      return state.filter(({ sid }) => sid !== invitationSid);
    }
    case AuthActionTypes.LOGOUT:
      return initialState;
    default:
      return state;
  }
}
